<div id="view-gross-revenue-branch-advisors-dialog">
    <div id="dialog-title" mat-dialog-title>
        <span id="dialog-header">Incepted APE - By Advisors [{{this.branchName}}]</span>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content>
        <div class="position-relative" style="max-width: 500px">
            <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                style="background: #f0f0f0; color: #1c3a7a" [formControl]="grossRevenueByAdvisorTableFilterFc"
                (keyup)="__applyGrossRevenueByAdvisorDataFilter()" placeholder="Search advisors..." #input />

            <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y" style="color: #888888"></i>

            <button *ngIf="grossRevenueByAdvisorTableFilterFc.value"
                class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                (click)="clearSearchField()">
                <i class="fas fa-times" style="color: #888888"></i>
            </button>
        </div>
        <mat-divider class="pias-divider"></mat-divider>
        <div class="pias-table-container" id="view-gross-revenue-branch-advisors-table">
            <table mat-table class="pias-table table table-hover table-bordered bg-light border border-2"
                [dataSource]="grossRevenueByAdvisorTableDataSource" matSort matSortDisableClear matSortActive="totalGrossRevenueYtd"
                matSortDirection="desc" #grossRevenueByAdvisorTableSort="matSort">

                <!-- Rep. Code Column -->
                <ng-container matColumnDef="repCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Rep.
                        Code </th>
                    <td mat-cell *matCellDef="let grData" class="text-start" style="max-width: 100px;">
                        {{grData.repCode}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="personName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Name
                    </th>
                    <td mat-cell *matCellDef="let grData" class="text-start" style="max-width: 150px;">
                        {{grData.personName}} </td>
                </ng-container>

                <!-- Life Insurance Ytd Column -->
                <ng-container matColumnDef="lifeInsuranceYtd">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Life
                        <br> Insurance
                    </th>
                    <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.lifeInsuranceYtd| currency:
                        'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <!-- Investment Ytd Column -->
                <ng-container matColumnDef="investmentYtd">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                        Investment </th>
                    <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.investmentYtd| currency:
                        'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <!-- General Insurance Ytd Column -->
                <ng-container matColumnDef="generalInsuranceYtd">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                        General <br> Insurance </th>
                    <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.generalInsuranceYtd|
                        currency: 'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <!-- Fee And Referrals Ytd Column -->
                <ng-container matColumnDef="feeAndReferralYtd">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Fees
                        <br> & Referrals
                    </th>
                    <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.feeAndReferralYtd|
                        currency: 'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <!-- Total Gross Revenue Ytd Column -->
                <ng-container matColumnDef="totalGrossRevenueYtd">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold">
                        Total  <br> Gross Revenue </th>
                    <td mat-cell *matCellDef="let grData" class="text-end"> {{grData.totalGrossRevenueYtd|
                        currency: 'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="grossRevenueByAdvisorTableDisplayColumn; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: grossRevenueByAdvisorTableDisplayColumn;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="7">No data found.</td>
                </tr>
            </table>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        <!-- Gross Revenue (By advisor) Table Paginator -->
        <mat-paginator #grossRevenueByAdvisorTablePaginator [pageSizeOptions]="[10,20,50]" showFirstLastButtons
            aria-label="Select page of gross revenue by advisor data"></mat-paginator>
    </mat-dialog-actions>
</div>